import { useState } from 'react'
import clsx from 'clsx'
import { RiArrowDownSLine } from '@remixicon/react'
import { Filter } from '../../postFilters.styles'
import { List, ListItem, Wrapper } from './dropdown.styles'
import { DropdownProps } from './dropdown.types'

const Dropdown = ({ label, disabled, items, className }: DropdownProps) => {
  const [openDropdown, setOpenDropdown] = useState(false)

  const handleOpenDropdown = () => {
    setOpenDropdown(true)
  }

  const handleCloseDropdown = () => {
    setOpenDropdown(false)
  }

  const handleItemClick = (callback: () => void) => {
    callback()
    handleCloseDropdown()
  }

  return (
    <Wrapper className="_d-flex _flex-column _justify-content-center _align-items-end _position-relative">
      <Filter className={className} disabled={disabled} onClick={handleOpenDropdown}>
        <RiArrowDownSLine size={16} className="_text-gray-900 _mr-1" />
        {label}
      </Filter>

      <List className="_border _border-gray-200" open={openDropdown} close={handleCloseDropdown}>
        {items.map(({ label, onClick }, index, array) => (
          <ListItem
            key={label}
            className={clsx(
              '_font-14 _d-flex _align-items-center _justify-content-start _text-gray-900 _px-4 _py-4 _text-nowrap _text-left',
              {
                '_border-bottom _border-gray-200': index !== array.length - 1
              }
            )}
            onClick={() => handleItemClick(onClick)}
          >
            {label}
          </ListItem>
        ))}
      </List>
    </Wrapper>
  )
}

export default Dropdown
